import React, { useState } from 'react'
import useModal from './modalHook';
import { CreateCountry } from '../views/shared/settings/countries';
import { getAllOperationalCountries } from '../api/requests';
import { useQuery } from '@tanstack/react-query';

const useCountries = () => {

    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const CountriesModal = ModalComponent;
    const [loading, setLoading] = useState<boolean>(true);
    const [countries, setCountries] = useState<any>([]);
    

    useQuery({
        queryKey: ['getCountries', countries],
        queryFn: ()=> getCountries()
    })

     const getCountries = () => {
            // Runs as a React Query queryFn — return a defined value (never undefined).
            return getAllOperationalCountries()
                .then((response: any) => {
                    setCountries(response);
                    return response ?? null;
                })
                .catch((error: any) => null)
                .finally(() => {
                    setLoading(false);
                });
        };
        
      const addCountry = () => {
        updateModalStates({
            show: true,
            size: 'sm',
            children: (
                <CreateCountry
                    onProceed={() => {
                        closeModal();
                        getCountries()
                        // queryClient.invalidateQueries({ queryKey: ['getCountries'] });
                    }}
                    onClose={closeModal}
                />
            ),
            
            classes: '!p-0 r-[5px]'
        });
    }
  return {
    addCountry,
    CountriesModal,
    loading,
    countries
  }
}

export default useCountries